import { alpha } from '@mui/material/styles';
import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

export const cameraPillSx = (theme: Theme): SystemStyleObject<Theme> => ({
  height: 28,
  borderRadius: 999,
  bgcolor: alpha(theme.palette.common.black, 0.5),
  backdropFilter: 'blur(10px)',
});
